import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Cancel as CancelIcon
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2)
  },
  paper: {
    padding: theme.spacing(4),
    textAlign: 'center',
    maxWidth: 400,
    width: '100%'
  },
  iconContainer: {
    marginBottom: theme.spacing(2)
  },
  cancelIcon: {
    fontSize: 64,
    color: theme.palette.warning.main
  },
  button: {
    marginTop: theme.spacing(2)
  }
}));

const FacebookCanceled = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleReturnToSettings = () => {
    if (window.opener) {
      // Si es un popup, comunicar al padre y cerrar
      window.opener.postMessage({
        type: 'FACEBOOK_AUTH_CANCELED',
        timestamp: new Date().toISOString()
      }, window.location.origin);
      window.close();
    } else {
      // Si es una página normal, redirigir
      history.push('/connections');
    }
  };

  return (
    <Box className={classes.container}>
      <Paper className={classes.paper}>
        <Box className={classes.iconContainer}>
          <CancelIcon className={classes.cancelIcon} />
        </Box>
        <Typography variant="h6" gutterBottom>
          Autorización Cancelada
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Has cancelado la autorización con Facebook. Puedes intentarlo nuevamente cuando desees conectar tu cuenta de WhatsApp Business.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={handleReturnToSettings}
        >
          {window.opener ? 'Cerrar' : 'Volver a Conexiones'}
        </Button>
      </Paper>
    </Box>
  );
};

export default FacebookCanceled;
